import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import { useMode } from "@/shared/api";
import { ROUTES } from "@/shared/config";
import { ScreenState } from "@/widgets/screen-state";
import { TopBar } from "@/widgets/top-bar";

/**
 * Раздел, которого в демо-режиме нет (доработки §3.1).
 *
 * Так закрыты пополнение, вывод, рейтинг и реферальная программа. Причина у
 * каждого своя, но следствие одно: §3.1 запрещает выводить демо-средства и
 * переводить их в реальный баланс, а рейтинг по требованию §5 считается по
 * реальным результатам и демо-аккаунты из него исключены.
 *
 * Экран не просто отказывает, а предлагает выход: кнопка переводит в реальный
 * режим и уводит туда же, куда человек шёл. Тупик без выхода читался бы как
 * поломка.
 */
export function DemoUnavailablePage({ titleKey }: { titleKey: string }) {
  const { t } = useTranslation();
  const { setMode } = useMode();
  const navigate = useNavigate();

  return (
    <div className="flex flex-col gap-3 px-5 py-3">
      <TopBar title={t(titleKey)} subtitle={t("demo.unavailable.subtitle")} />
      <ScreenState
        tone="info"
        icon="warningFill"
        title={t("demo.unavailable.title")}
        body={t("demo.unavailable.body")}
        action={{
          label: t("demo.unavailable.action"),
          onClick: () => {
            setMode("real");
            void navigate(ROUTES.home);
          },
        }}
      />
    </div>
  );
}
